import type { Dictionary } from 'shared/legacy/contexts/LocalizationContext/types';

import { IndeedCandidateAlreadyContactedException } from './IndeedCandidateAlreadyContactedException';
import { IndeedCandidateEngagementException } from './IndeedCandidateEngagementException';
import { IndeedCandidateRecentlyDeclinedException } from './IndeedCandidateRecentlyDeclinedException';
import { IndeedCandidateSubscriptionMismatchException } from './IndeedCandidateSubscriptionMismatchException';

export const getIndeedCandidateEngagementErrorMessage = (error: unknown, dictionary: Dictionary) => {
  if (error instanceof IndeedCandidateAlreadyContactedException) {
    return dictionary.indeedCandidateAlreadyContacted;
  }

  if (error instanceof IndeedCandidateRecentlyDeclinedException) {
    return dictionary.indeedCandidateRecentlyDeclined;
  }

  if (error instanceof IndeedCandidateSubscriptionMismatchException) {
    return dictionary.indeedCandidateSubscriptionMismatch;
  }

  if (error instanceof IndeedCandidateEngagementException) {
    return dictionary.indeedCandidateEngagementFailed;
  }

  return null;
};
